var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.loaderClass},[_c('div',{staticClass:"card"},[(_vm.saving)?_c('div',{staticClass:"card-body"},[_vm._v("Trwa generowanie plakatu")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }